import { Component, EventEmitter, HostListener, Input, NO_ERRORS_SCHEMA, Output } from '@angular/core';
import { TextEditorComponent } from 'simpo-component-library';

@Component({
  selector: 'app-simpo-text-editor',
  standalone: true,
  imports: [TextEditorComponent],
  schemas: [NO_ERRORS_SCHEMA],
  template: `
    <simpo-text-editor
      [value]="value"
      [editable]="editable"
      (valueChange)="onValueChange($event)">
    </simpo-text-editor>
  `
})
export class SimpoTextEditorWrapperComponent {
  @Input() value: string = '';
  @Input() editable: boolean = false;
  @Output() valueChange = new EventEmitter<string>();

  @HostListener('keydown', ['$event'])
  stopKeyPropagation(event: KeyboardEvent): void {
    event.stopPropagation();
  }

  onValueChange(newValue: string): void {
    this.value = newValue;
    this.valueChange.emit(newValue);
  }
}
